import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { getPositionsData } from 'models/positions'; // Importing function to get positions data

/**
 * PositionsView class extends JetView to create a view for displaying positions data.
 */
export default class PositionsView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for text translation
        return {
            type: 'clean', // Clean layout type
            rows: [
                {
                    template: _('Clients by occupation'), // Header template with localized text
                    type: 'header', // Header type
                    css: 'webix_header chart_header', // CSS class for styling
                },
                {
                    view: 'chart', // Chart view
                    type: 'donut', // Donut chart type
                    localId: 'chart', // Local ID for referencing the chart
                    value: '#number#', // Data field for chart value
                    lineColor: (obj) => obj.color, // Function to set line color based on data
                    color: '#color#', // Data field for chart color
                    innerRadius: 60, // Inner radius for the donut chart
                    padding: { top: 10, bottom: 20, left: 20 }, // Padding around the chart
                    legend: {
                        width: 170, // Width of the legend
                        align: 'right', // Alignment of the legend
                        valign: 'middle', // Vertical alignment of the legend
                        marker: {
                            type: 'round', // Marker type for legend
                            width: 7, // Marker width
                            height: 8, // Marker height
                        },
                        template: (obj) => _(obj.position), // Template for legend items with localized text
                    },
                    shadow: false, // Disable shadow for the chart
                    tooltip: {
                        template: (obj) => `${_('Clients')}: ${obj.number}`, // Tooltip template with localized text
                    },
                },
            ],
        };
    }

    /**
     * Initializes the view and populates the chart with data.
     */
    init() {
        this.$$('chart').parse(getPositionsData()); // Parsing positions data into the chart
    }
}

// FILE DOCUMENTED
